import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Map } from 'immutable'
import { reduxForm, formValueSelector, change } from 'redux-form/immutable'
import { PROMO_PAGE_DEFAULTS } from '@prohabits/metaverse'

import { updateOrgPromoPage } from 'store/entities/organizationSettings/actions'

import { getOrganizationSettingsByDomain, getPromoPageSettings } from 'store/entities/organizationSettings/selectors'
import { organizationId } from 'store/entities/router/selectors'
import { getViewOrganizationSettingsLogo } from 'store/entities/organizations/selectors'

import Small from './bigVariant'

import { modal } from 'store/entities/modal/actions'

import { syncValidate_v2 } from 'app/validators/promoPageSettings'

const formName = `PROMO_PAGE_SETTINGS_FORM_V2`

const selector = formValueSelector(formName)

const mapStateToProps = createStructuredSelector({
  organizationSettings: getOrganizationSettingsByDomain,
  promoPage: getPromoPageSettings,
  // @ts-ignore
  welcomeTextInputValue: state => selector(state, 'welcomeText_v2'),
  // @ts-ignore
  titleInputValue: state => selector(state, 'title_v2'),
  // @ts-ignore
  subTitleInputValue: state => selector(state, 'subTitle_v2'),
  // @ts-ignore
  formTitleInputValue: state => selector(state, 'formTitle_v2'),
  // @ts-ignore
  formSubTitleInputValue: state => selector(state, 'formSubTitle_v2'),
  // @ts-ignore
  quoteAuthorInputValue: state => selector(state, 'quoteAuthor_v2'),
  // @ts-ignore
  quoteAuthorAboutInputValue: state => selector(state, 'quoteAuthorAbout_v2'),
  // @ts-ignore
  quoteInputValue: state => selector(state, 'quote_v2'),
  // @ts-ignore
  secondTitleInputValue: state => selector(state, 'secondTitle_v2'),
  // @ts-ignore
  secondSubTitleInputValue: state => selector(state, 'secondSubTitle_v2'),
  // @ts-ignore
  textBoxesHeaderInputValue: state => selector(state, 'textBoxesHeader_v2'),
  // @ts-ignore
  firstBoxTitleInputValue: state => selector(state, 'firstBoxTitle_v2'),
  // @ts-ignore
  firstBoxSubTitleInputValue: state => selector(state, 'firstBoxSubTitle_v2'),
  // @ts-ignore
  secondBoxTitleInputValue: state => selector(state, 'secondBoxTitle_v2'),
  // @ts-ignore
  secondBoxSubTitleInputValue: state => selector(state, 'secondBoxSubTitle_v2'),
  // @ts-ignore
  thirdBoxTitleInputValue: state => selector(state, 'thirdBoxTitle_v2'),
  // @ts-ignore
  thirdBoxSubTitleInputValue: state => selector(state, 'thirdBoxSubTitle_v2'),
  // @ts-ignore
  fourthBoxTitleInputValue: state => selector(state, 'fourthBoxTitle_v2'),
  // @ts-ignore
  fourthBoxSubTitleInputValue: state => selector(state, 'fourthBoxSubTitle_v2'),
  // @ts-ignore
  mainBackgroundInputValue: state => selector(state, 'mainBackground_v2'),
  // @ts-ignore
  proQuoteAuthorImageInputValue: state => selector(state, 'proQuoteAuthorImage_v2'),
  // @ts-ignore
  platformAboutImageInputValue: state => selector(state, 'platformAboutImage_v2'),
  // @ts-ignore
  firstBoxImageInputValue: state => selector(state, 'firstBoxImage_v2'),
  // @ts-ignore
  secondBoxImageInputValue: state => selector(state, 'secondBoxImage_v2'),
  // @ts-ignore
  thirdBoxImageInputValue: state => selector(state, 'thirdBoxImage_v2'),
  // @ts-ignore
  fourthBoxImageInputValue: state => selector(state, 'fourthBoxImage_v2'),

  organizationId,
  /* this only for the admin to show him logo of organization which is in editing progress */
  currentOrganizationLogo: getViewOrganizationSettingsLogo,
})

const mapDispatchToProps = {
  showModal: modal.show,
  change: (fieldName: string, value: string) => change(formName, fieldName, value),
}

const mergeProps = (
  { organizationSettings, promoPage, organizationId, currentOrganizationLogo, ...stateProps },
  dispatchProps,
  ownProps
) => {
  /*

    promoPage.get() - available for the admin in editing case
    
    organizationSettings.getIn(['promoPageSettings', 'fieldName']) - available for the client who is looking at the page,
    or for the admin when he will refresh the page manually

  */

  const { isPageEdit } = ownProps

  /*
      !isPageEdit - means that user is on the page, and we must display organization setting by domain
  */
  const getValue = (field: string) =>
    promoPage.get(field) ||
    (!isPageEdit && organizationSettings.getIn(['promoPageSettings', field])) ||
    PROMO_PAGE_DEFAULTS[field]

  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    logo: currentOrganizationLogo || organizationSettings.getIn(['organization', 'logo']),
    title: getValue('title_v2'),
    subTitle: getValue('subTitle_v2'),
    formTitle: getValue('formTitle_v2'),
    formSubTitle: getValue('formSubTitle_v2'),
    welcomeText: getValue('welcomeText_v2'),
    quote: getValue('quote_v2'),
    quoteAuthor: getValue('quoteAuthor_v2'),
    quoteAuthorAbout: getValue('quoteAuthorAbout_v2'),
    secondTitle: getValue('secondTitle_v2'),
    secondSubTitle: getValue('secondSubTitle_v2'),
    textBoxesHeader: getValue('textBoxesHeader_v2'),
    firstBoxTitle: getValue('firstBoxTitle_v2'),
    firstBoxSubTitle: getValue('firstBoxSubTitle_v2'),
    secondBoxTitle: getValue('secondBoxTitle_v2'),
    secondBoxSubTitle: getValue('secondBoxSubTitle_v2'),
    thirdBoxTitle: getValue('thirdBoxTitle_v2'),
    thirdBoxSubTitle: getValue('thirdBoxSubTitle_v2'),
    fourthBoxTitle: getValue('fourthBoxTitle_v2'),
    fourthBoxSubTitle: getValue('fourthBoxSubTitle_v2'),
    mainBackground: getValue('mainBackground_v2'),
    proQuoteAuthorImage: getValue('proQuoteAuthorImage_v2'),
    platformAboutImage: getValue('platformAboutImage_v2'),
    firstBoxImage: getValue('firstBoxImage_v2'),
    secondBoxImage: getValue('secondBoxImage_v2'),
    thirdBoxImage: getValue('thirdBoxImage_v2'),
    fourthBoxImage: getValue('fourthBoxImage_v2'),

    initialValues: Map({
      welcomeText_v2: getValue('welcomeText_v2'),
      title_v2: getValue('title_v2'),
      subTitle_v2: getValue('subTitle_v2'),
      formTitle_v2: getValue('formTitle_v2'),
      formSubTitle_v2: getValue('formSubTitle_v2'),
      quoteAuthor_v2: getValue('quoteAuthor_v2'),
      quote_v2: getValue('quote_v2'),
      quoteAuthorAbout_v2: getValue('quoteAuthorAbout_v2'),
      secondTitle_v2: getValue('secondTitle_v2'),
      secondSubTitle_v2: getValue('secondSubTitle_v2'),
      textBoxesHeader_v2: getValue('textBoxesHeader_v2'),
      firstBoxTitle_v2: getValue('firstBoxTitle_v2'),
      firstBoxSubTitle_v2: getValue('firstBoxSubTitle_v2'),
      secondBoxTitle_v2: getValue('secondBoxTitle_v2'),
      secondBoxSubTitle_v2: getValue('secondBoxSubTitle_v2'),
      thirdBoxTitle_v2: getValue('thirdBoxTitle_v2'),
      thirdBoxSubTitle_v2: getValue('thirdBoxSubTitle_v2'),
      fourthBoxTitle_v2: getValue('fourthBoxTitle_v2'),
      fourthBoxSubTitle_v2: getValue('fourthBoxSubTitle_v2'),
      mainBackground_v2: getValue('mainBackground_v2'),
      proQuoteAuthorImage_v2: getValue('proQuoteAuthorImage_v2'),
      platformAboutImage_v2: getValue('platformAboutImage_v2'),
      firstBoxImage_v2: getValue('firstBoxImage_v2'),
      secondBoxImage_v2: getValue('secondBoxImage_v2'),
      thirdBoxImage_v2: getValue('thirdBoxImage_v2'),
      fourthBoxImage_v2: getValue('fourthBoxImage_v2'),
    }),
    onSubmit: (values, dispatch) => {
      dispatch(
        updateOrgPromoPage({
          ...values.toJS(),
          organizationId,
        })
      )
    },
    validate: syncValidate_v2,
    touchOnChange: true,
  }
}

const formProps = {
  form: formName,
  destroyOnUnmount: true,
  enableReinitialize: true,
}

export default connect(mapStateToProps, mapDispatchToProps as any, mergeProps)(reduxForm(formProps)(Small as any))
